export default "__VITE_ASSET__BJmYpAsS__"